<template>
	<div>
		<modalcategoryproduct v-model="dialog" :propAdd='paramProp' :val = 'val'/>
		<modalconfirm ref="modalconfirmProductCategory" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Kategori Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="() => {dialog=true; paramProp='tambah'; val= {};}">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Kategori Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="productCategoryResults" :options.sync="option" :search="search" :server-items-length="productPagination.total_data" hide-default-footer>
				<template v-slot:item.product_category_name="{ item }">
					<div class="pb-2">{{ item.product_category_name }}</div>
				</template>
				<template v-slot:item.product_category_slug="{ item }">
					<div class="pt-2">{{ item.product_category_slug }}</div>
				</template>
				<template v-slot:item.product_category_is_active="{ item }">
					<v-switch v-model="item.product_category_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="() => {val= item; dialog=true; paramProp='edit'}" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="hapus(item.product_category_id, item.product_category_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!productPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="productPagination">
			<v-row>
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="productPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalcategoryproduct from '@/views/MLwarehouse/categoryProduct/ModalCategoryProduct'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalcategoryproduct
	},
	data() {
		return {
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			propDelete: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Kategori Produk', align: 'start', value: 'product_category_name'},
			{ text: 'Kategori Produk Slug', value: 'product_category_slug'},
			{ text: 'Aktif', value: 'product_category_is_active'},
			{ text: 'Aksi', value: 'action', sortable: false },
			],
			filterData: [{
				type: 'text',
				label: 'Nama Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_category_name'
				}
			}],
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_category_name'
			},
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('productList', ['productCategoryResults', 'productPagination', 'konfirmResponse']),
	},
	methods: {
		...mapActions('productList', ['getProductCategory', 'statusProductCategory', 'deleteCategory']),
		...mapMutations('productList', ['clearDataProduct']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			this.getProductCategory(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		editStatus(stat){
			this.paramStatus.id = stat.product_category_id
			if(stat.product_category_is_active == false){
				this.paramStatus.status = 'inactive'
			} else{
				this.paramStatus.status = 'active'
			}
			this.statusProductCategory(this.paramStatus).then(() => {
				this.getData()
			})
		},
		hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmProductCategory.setMessage(msg)
			this.$refs.modalconfirmProductCategory.showConfirm()
		},
		async deleteData () {
			await this.setOverlay(true)
			await this.deleteCategory(this.propDelete).then( () => {
				this.getData()
				this.$refs.modalconfirmProductCategory.hideConfirm()
			})
			await this.setOverlay(false)
		},
	},
	created() {
		this.setFilter(this.filterData)
		this.getData()
		this.$store.dispatch('setPageTitle', `Kategori Produk`)
	},
	beforeDestroy() {
		this.clearDataProduct()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>